import { createRoot } from "react-dom/client";
import { createElement } from "react";
import { KoraChat } from "widgets/KoraChat";

const getKoraChatContainer = () => document.getElementById("kora_chat_root");

export const isKoraChatEnabled = () => !!getKoraChatContainer();

export const renderKoraChat = () => {
    const container = getKoraChatContainer() as HTMLElement;
    const koraChatRoot = createRoot(container);
    koraChatRoot.render(createElement(KoraChat));
};
